import PropTypes from 'prop-types'

const SplashLayout = ({ children }) => children

SplashLayout.propTypes = {
   children: PropTypes.node.isRequired
}

export default SplashLayout
